import { IEditorState } from "../../../actions/pages/editor/editorActionCreator"
import { JSONRPCErrorCatch } from "../../../error/error"
import { ConvertContentFromEditorContent } from "../../../libs/converter/convert-content-from-editor-content"
import { JSONRPCClientBuilder } from "../../../request/JSONRPCClientBuilder"
import {
  EpisodeRPC,
  EpisodeSavingAction,
  UpdateEpisodeInput,
  Visiblity,
} from "../../../rpcs/dist/EpisodeRPC"
import { EDIT_TYPE } from "../types"

export class PostEpisodeService {
  private fetchData: IEditorState["fetchData"]
  private currentEditingState: IEditorState["currentEditingState"]

  constructor(
    fetchData: IEditorState["fetchData"],
    currentEditingState: IEditorState["currentEditingState"],
  ) {
    this.fetchData = fetchData
    this.currentEditingState = currentEditingState
  }

  public async post(postData: UpdateEpisodeInput) {
    const episodeRPC = JSONRPCClientBuilder.build(EpisodeRPC)
    return await episodeRPC.updateEpisode(postData).catch(JSONRPCErrorCatch)
  }

  public async validateWithPost(visibility: Visiblity) {
    if (this.hasEditingContent()) {
      throw new Error("編集中のコンテンツを完了させてください")
    }
    const postData = this.createPostData(visibility)
    const res = await this.post(postData)
    if (res === -1) {
      throw new Error("投稿に失敗しました")
    }
    return res
  }

  public createPostData(visibility: Visiblity): UpdateEpisodeInput {
    const { fetchData, currentEditingState } = this

    return {
      displayId: fetchData.episode!.displayId,
      title: currentEditingState.title || "",
      content: JSON.stringify(
        ConvertContentFromEditorContent(currentEditingState.contents || []),
      ),
      channelName: this.getSelectedChannelName(),
      action: this.calcAction(visibility),
      tags: currentEditingState.tags || [],
    }
  }

  public hasEditingContent(): boolean {
    return (this.currentEditingState.contents || []).some(
      c => c._editMetaData.type === EDIT_TYPE.EDIT,
    )
  }

  private calcAction(selectedVisibility: Visiblity): EpisodeSavingAction {
    if (this.fetchData.episode!.visiblity === selectedVisibility) {
      return EpisodeSavingAction.Update
    }
    switch (selectedVisibility) {
      case Visiblity.Draft:
        return EpisodeSavingAction.Draft
      case Visiblity.Public:
        return EpisodeSavingAction.Publish
      default:
        return EpisodeSavingAction.Update
    }
  }

  private getSelectedChannelName(): string | null {
    if (this.currentEditingState.selectedChannelId) {
      const selectedChannel = (this.fetchData.channels || []).find(
        c => c.id === this.currentEditingState.selectedChannelId,
      )
      if (selectedChannel) {
        return selectedChannel.name
      }
    }
    return null
  }
}
